import Swiper, { Autoplay, Navigation } from 'swiper';
import { swiperObserver } from '../utils/swiper.utils.js';
import { duplicateSwiperSlides } from '../utils/duplicateSlides.utils';

let numbersSwiperWr = document.querySelectorAll('.numbers-swiper-wr');

numbersSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let parentEl = el.parentElement;
    let nextEl = parentEl.querySelector('.swiper-button-next');
    let prevEl = parentEl.querySelector('.swiper-button-prev');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    let wrapper = swiperEl?.querySelector('.swiper-wrapper');

    duplicateSwiperSlides('numbers-swiper-wr', 2)

    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation],
      observer: true, //needs to calculate swiper size
      observeParents: true, //needs to calculate swiper size
      spaceBetween: 24,
      slidesPerView: 'auto',
      loop: true,
      threshold: 10,
      // navigation: {
      //   nextEl: nextEl,
      //   prevEl: prevEl,
      // },
      breakpoints: {
        480: {
          spaceBetween: 36,
        },
        768: {
          spaceBetween: 64,
        },
        1200: {
          spaceBetween: 110,
        }
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: window.innerWidth >= 640,
      },

      // on: {
      //   init: (swiper) => {
      //     parentEl.querySelector('.swiper-buttons').classList.toggle('buttons-hidden', swiper.slides.length === swiper.params.slidesPerView);
      //   },
      //   breakpoint: (swiper) => {
      //     parentEl.querySelector('.swiper-buttons').classList.toggle('buttons-hidden', swiper.slides.length === swiper.params.slidesPerView);
      //   }
      // },
    });
    // swiperObserver(swiper);
  }
});